/**************************************************
 * Nombre:       Escuelas_QueProgramas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {NEGRITA} from "../../../Constantes";
import logo from '../../../Recursos/logo_color.svg'
import Tarjeta_Curso from "../../Tarjetas/Tarjeta_Curso";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {useContext, useEffect, useState} from "react";
import {contexApp} from "../../../App";


const Escuelas_QueProgramas = ({item}) => {
    const {sCell} = useResponsive()
    const cData = useContext(contexApp)
    const [tecnicos, setTecnicos] = useState([])

    useEffect(() => {

        if (cData.programas.length > 0) {

            let arr = cData.programas.filter((e) => e.idEscuela === item.id)
            setTecnicos(arr)
        }

    }, [cData, item]);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}
                      spacing={8}
                >
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 6}}
                        spacing={0}
                    >


                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 8}}>
                            <Typography sx={{
                                fontSize: sCell ? 32 : 40,
                                fontFamily: NEGRITA,
                                lineHeight: 1.1,
                                fontWeight: 600,
                                textAlign: sCell ? 'center' : 'left',
                            }}>
                                ¿Que programas la conforman?
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{
                                  justifyContent: 'flex-start',
                                  mt: 1,
                                  textAlign: sCell ? 'center' : 'left',
                                  lineHeight: 1.3,
                              }}>
                            <Typography
                                sx={{fontSize: 18}}>
                                {item.justificacion}
                            </Typography>
                        </Grid>


                    </Grid>

                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 6}}
                        sx={{mt: sCell ? 0 : 10}}
                    >

                        <img src={logo} width={sCell ? '60%' : '80%'} height={'auto'}/>
                    </Grid>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={8}
                        sx={{mt: sCell ? 2 : 8}}
                    >

                        {tecnicos.map((item, index) => (
                            <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>
                                <Tarjeta_Curso item={item}/>
                            </Grid>
                        ))}

                    </Grid>

                </Grid>


            </Grid>

        </Grid>
    )

}
export default Escuelas_QueProgramas

const items = [1, 2, 3, 4, 5, 6]